"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
function default_1(value) {
    return Boolean(value === null || value === void 0 ? void 0 : value.replace(/\s/g, '').length);
}
exports.default = default_1;
